module.exports = __webpack_public_path__ + "static/img/guide-deneigement_06.1b257b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide-deneigement_06.jpg
// module id = 6tux
// module chunks = 1